module.exports = __webpack_public_path__ + "static/img/eureka_icon_10.aaa994ec.png";